<template>
    <!-- @after-enter="afterEnter" -->
    <pop
        customClass="sb-sug-pop"
        animation="bottomToUp"
        :allowClose="false"
    >
        <div class="m-select-filtable" :style="colorStyle">
            <h2 class="title">
                <div class="icon" @click="back">
                    <span class="iconfont icon-prev"></span>
                </div>
                <div class="title_wrap">
                    <div class="title_content">{{ data.label }}</div>
                </div>
            </h2>
            <div class="input" ref="ref_input">
                <im-input v-model:value="input" :searchable="true" />
            </div>

            <div class="content">
                <div :key="index" v-for="(option, index) in options">
                    <div class="list_label">{{ option.label }}</div>
                    <div class="list">
                        <div
                            class="list-item"
                            :class="[theme]"
                            v-for="opt in option.data"
                            :key="opt.value"
                            @click="handleClk(opt)"
                        >
                            <div class="label">
                                <div class="label_content">
                                    {{ opt.label }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </pop>
</template>

<script>
import util from '../../../../common/util';
export default {
    emits: ['select', 'close'],
    name: 'MSuggestionPop',
    props: {
        parentIns: { 
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        theme() {
            return this.parentIns.theme;
        },
        data: function() {
            return this.parentIns.data;
        },
        needGroup() {
            return this.parentIns.needGroup;
        },
        options() {
            return this.parentIns.options;
        },
        onRemoteMethod() {
            return this.parentIns.onRemoteMethod;
        },
        colorStyle() {
            return this.parentIns.colorStyle;
        }
    },
    data: function() {
        return {
            input: ''
        };
    },
    created() {
        this.debounceRemoteMethod = util
            .debounce(this.onRemoteMethod)
            .bind(this);
    },
    watch: {
        input(val) {
            this.debounceRemoteMethod(val);
        }
    },
    methods: {
        back() {
            this.close();
            this.destroy();
        },
        handleClk(item) {
            this.$emit('select', item);
            this.close();
            this.destroy();
        },
        close() {
            this.$emit('close');
        }
    }
};
</script>
<style lang="scss">
.sb-sug-pop {
    top: 0 !important;
    .m-select-filtable {
        position: relative;
        height: 100%;
        width: 100%;
        background: var(--g-bg-color);
    }
    .title {
        height: 60px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        border: solid 1px #e2e4ea;
    
        /* padding: 15px 0; */
        .icon {
            padding: 0 15px;
            display: flex;
            align-items: center;
            justify-content: center;
            .iconfont {
                color: var(--g-text-color);
                font-size: 14px;
            }
        }
        .title_wrap {
            flex: 1 0 0;
            padding-right: 15px;
            display: flex;
            align-items: center;
            justify-content: center;
            .title_content {
                width: 100%;
                text-align: center;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-weight: 500;
                color: var(--g-primary-color);
                font-size: 16px;
            }
        }
    }
    .input {
        padding: 10px 15px;
        height: 60px;
        color: var(--g-text-color);
    }
    .list_label {
        padding: 0 25px;
        font-weight: 700;
        color: var(--g-primary-color);
        height: 40px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .content {
        height: calc(100% - 120px);
        overflow: auto;
    }
    .list {
        overflow: auto;
        padding: 0 25px;
        .list-item {
            height: 40px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            &.standard {
                color: var(--g-text-color);
                .iconfont {
                    color: var(--g-btn-background);
                }
            }
            &.template1 {
                color: #202437;
                .iconfont {
                    color: #249bff;
                }
            }
            &.template4 {
                color: #646978;
                .iconfont {
                    color: #4c84ff;
                }
            }
            .label {
                flex: 1 0 0;
                overflow: hidden;
                .label_content {
                    width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
            .icon {
                width: 25px;
                padding-left: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }
}
</style>
